import React from 'react';

const GooglePlay: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={137}
      height={41}
      viewBox="0 0 137 41"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-938 -699) translate(274 670.5) translate(664.5 29)">
              <rect width={136} height={40} fill="#F2F2F2" rx={4} />
              <g fill="#3A3A3A" fontFamily="Public Sans, sans-serif">
                <text fontSize={14} transform="translate(53.148 3.25)">
                  <tspan x="40.059" y="27.745">
                    play
                  </tspan>
                </text>
                <text fontSize={10} transform="translate(53.148 3.25)">
                  <tspan x=".01" y={10}>
                    Disponible en
                  </tspan>
                </text>
              </g>
              <g fill="#565656" fillRule="nonzero">
                <path
                  d="M2.4 21.322V2.68c0-.65.377-1.213.924-1.48l10.784 10.798L3.32 22.8c-.545-.268-.92-.829-.92-1.478zm15.13-5.899L5.738 22.24l9.3-9.312 2.492 2.495zm3.665-4.729c.392.3.645.774.645 1.307 0 .525-.245.992-.627 1.293l-2.505 1.448-2.741-2.744 2.74-2.743 2.488 1.44zM5.745 1.763l11.783 6.811-2.49 2.493-9.293-9.304z"
                  transform="translate(9.389 10)"
                />
              </g>
              <g fill="#3A3A3A">
                <path
                  d="M46.083 8.687c1.015 0 1.817.452 2.23.953h.063l.013-.69h1.767v7.608c0 3.133-1.842 4.412-4.023 4.412-2.055 0-3.296-1.379-3.76-2.507l1.617-.677c.288.69.99 1.504 2.13 1.504 1.392 0 2.256-.864 2.256-2.481v-.614h-.062c-.414.514-1.216.965-2.231.965-2.118 0-4.06-1.855-4.06-4.224 0-2.381 1.942-4.249 4.06-4.249zm12.094.013c2.194 0 3.272 1.742 3.622 2.695l.201.476-5.665 2.343c.439.84 1.115 1.279 2.055 1.279.94 0 1.605-.464 2.08-1.166l1.442.965c-.463.69-1.591 1.88-3.534 1.88-2.406 0-4.199-1.867-4.199-4.236 0-2.52 1.818-4.236 3.998-4.236zm-21.18-.013c2.343 0 4.248 1.793 4.248 4.236 0 2.444-1.905 4.237-4.249 4.237-2.343 0-4.248-1.793-4.248-4.237 0-2.456 1.905-4.236 4.248-4.236zm-9.275 0c2.344 0 4.249 1.793 4.249 4.236 0 2.444-1.905 4.237-4.25 4.237-2.343 0-4.248-1.793-4.248-4.237 0-2.456 1.905-4.236 4.249-4.236zM16.68 4c2.005 0 3.434.79 4.512 1.817l-1.266 1.266c-.777-.714-1.817-1.278-3.246-1.278-2.644 0-4.712 2.13-4.712 4.775 0 2.644 2.068 4.775 4.712 4.775 1.717 0 2.695-.69 3.321-1.316.514-.514.853-1.253.978-2.268H16.68V9.978l6.041.013c.063.326.1.714.1 1.128 0 1.34-.363 3.008-1.554 4.198-1.153 1.204-2.632 1.843-4.587 1.843-3.634 0-6.68-2.958-6.68-6.58S13.058 4 16.68 4zm36.597.464v12.445h-1.855V4.464h1.855zm-16.28 5.89c-1.291 0-2.394 1.04-2.394 2.57 0 1.503 1.115 2.569 2.393 2.569 1.279 0 2.382-1.066 2.394-2.57 0-1.528-1.103-2.569-2.394-2.569zm9.249 0c-1.278 0-2.356 1.09-2.356 2.582 0 1.479 1.078 2.557 2.356 2.557 1.266 0 2.256-1.066 2.256-2.557 0-1.491-.99-2.582-2.256-2.582zm-18.524 0c-1.291 0-2.394 1.04-2.394 2.57 0 1.503 1.115 2.569 2.394 2.569 1.278 0 2.381-1.066 2.394-2.57 0-1.528-1.116-2.569-2.394-2.569zM58.397 10c-1.158 0-2.757 1.005-2.696 3l4.6-1.904C60.056 10.442 59.294 10 58.396 10z"
                  transform="translate(29 14.25)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default React.memo(GooglePlay);
